///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ExcelIcon = ({
  height,
  fill,
  title = messages.excel.defaultMessage,
  width,
  ...rest
}) => (
  <svg
    aria-labelledby="excel-icon"
    height={height}
    viewBox="0 0 20 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="excel-icon">{title}</title>
    <polygon
      fill={fill}
      id="Path"
      points="12 16 10.44375 16 8.94375 13.3469388 7.44375 16 6 16 8.1375 12.3877551 6.13125 9 7.63125 9 9.01875 11.5102041 10.36875 9 11.83125 9 9.80625 12.4693878"
    ></polygon>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M16.2,22 L1.8,22 C0.81,22 0,21.2016129 0,20.2258065 L0,1.77419355 C0,0.798387097 0.81,0 1.8,0 L9.126,0 C9.612,0 10.062,0.177419355 10.404,0.514516129 L17.478,7.48709677 C17.82,7.82419355 18,8.26774194 18,8.74677419 L18,20.2258065 C18,21.2016129 17.19,22 16.2,22 Z M1.8,0.709677419 C1.206,0.709677419 0.72,1.18870968 0.72,1.77419355 L0.72,20.2258065 C0.72,20.8112903 1.206,21.2903226 1.8,21.2903226 L16.2,21.2903226 C16.794,21.2903226 17.28,20.8112903 17.28,20.2258065 L17.28,8.74677419 C17.28,8.46290323 17.172,8.19677419 16.956,8.0016129 L9.882,1.02903226 C9.684,0.816129032 9.414,0.709677419 9.126,0.709677419 L1.8,0.709677419 Z"
      id="Shape"
      stroke={fill}
    />
  </svg>
);

export default ExcelIcon;
